import { createRouter, createWebHistory } from 'vue-router'
import Landing from '../pages/Landing.vue'
import DemoCompetition from '../pages/DemoCompetition.vue'

// Legacy pages kept for reference but not linked in demo nav
import CreateCompetition from '../pages/CreateCompetition.vue'
import JoinCompetition from '../pages/JoinCompetition.vue'
import JoinForm from '../pages/JoinForm.vue'
import CompetitionDetails from '../pages/CompetitionDetails.vue'
import ActiveCompetition from '../pages/ActiveCompetition.vue'
import MyCompetitions from '../pages/MyCompetitions.vue'
import MyPortfolio from '../pages/MyPortfolio.vue'
import ModerateCompetition from '../pages/ModerateCompetition.vue'
import Compete from '../pages/Compete.vue'
import Auth from '../pages/Auth.vue'

const routes = [
  { path: '/', name: 'Home', component: Landing },
  { path: '/competition', name: 'Competition', component: DemoCompetition },

  // Legacy routes (backend-coupled, not linked in demo)
  { path: '/auth', name: 'Auth', component: Auth },
  { path: '/create', name: 'CreateCompetition', component: CreateCompetition },
  { path: '/join', name: 'JoinCompetition', component: JoinCompetition },
  { path: '/join-form', name: 'JoinForm', component: JoinForm },
  { path: '/compete', name: 'Compete', component: Compete },
  { path: '/competition/:id', name: 'CompetitionDetails', component: CompetitionDetails },
  { path: '/active-competition/:id', name: 'ActiveCompetition', component: ActiveCompetition },
  { path: '/my-competitions', name: 'MyCompetitions', component: MyCompetitions },
  { path: '/my-portfolio', name: 'MyPortfolio', component: MyPortfolio },
  { path: '/moderate/:id', name: 'ModerateCompetition', component: ModerateCompetition },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
